<template>
  <div v-if="current_staff">
    <staff-form v-model="current_staff"></staff-form>
  </div>
</template>
<script>
import Api from '@/store/jsonapi';

export default {
  data: function () {
    return {
      current_staff: null
    };
  },
  mounted: function () {
    Api.find('staffs', this.staff_id, { include: 'user_group,organization' })
      .then(({ data }) => {
        this.current_staff = data;
      })
      .catch(function () {
        console.error('Failed loading staff');
      });
  },
  props: ['staff_id']
};
</script>
